import { sh } from '@tpluscode/rdf-ns-builders';
import { emptyPatterns, flatten, union } from '../lib/shapePatterns.js';
export default class {
    constructor(constraints) {
        this.constraints = constraints;
    }
    buildLogicalConstraints({ focusNode, variable, rootPatterns }) {
        if (!this.constraints.length) {
            return emptyPatterns;
        }
        const sum = this.constraints
            .filter((l) => l.type.equals(sh.AndConstraintComponent))
            .flatMap(l => l.inner.map(i => i.buildPatterns({ focusNode, variable, rootPatterns })))
            .filter(Boolean);
        const alternatives = this.constraints
            .filter((l) => l.type.equals(sh.OrConstraintComponent))
            .map(l => union(...l.inner.map(i => i.buildPatterns({ focusNode, variable, rootPatterns }))))
            .filter(Boolean);
        return flatten(...sum, ...alternatives);
    }
}
